import React,{useEffect,useState} from 'react'
import {default as wait} from 'wait'
import {BrowserRouter,Switch,Route} from 'react-router-dom'
import {Search} from '../Search';
import Footer from '../Footer'

function App() {
    const [Data, setData] = useState(false);
    useEffect(async () => {
     if (!Data) {
       await wait(1000);
       setData(true);
     } 
    });
    if (Data) {
      return (
        <BrowserRouter>
         <Switch>
           <Route path="/" exact render={props=><Search {...props}/>}/>
        </Switch>
            <Footer/>
        </BrowserRouter> 
    );
} else {
    return (
      <div>Loading...</div>
    )
  }
  }
  
  export default App;
  